import { Fragment } from 'react';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { Workbench } from './views/Workbench';

const LayoutComponent = () => (
	<Fragment>
		<Background />
		<Workbench />
	</Fragment>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.Workbench)
	.build();

export default Layout;
